import { Component, OnInit, ViewChild } from "@angular/core";
import { ModalComponent } from "../modal/modal.component";
import * as moment from "moment/moment";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { CommonService } from "src/app/common.service";
import { ShowcaseList, ShowcaseCard } from "showcase-api";
import { Profile } from "profile-api";
import { Router } from "@angular/router";
import {
  TenderList,
  TenderCard,
  Participation,
  Tender,
  TenderInvitation,
} from "tender-api";
import {
  GetTenderCategoryByCode,
  GetTenderStatusDescription,
} from "../utils/tender-utils";

@Component({
  selector: "app-showcase-company",
  templateUrl: "./showcase-company.component.html",
  styleUrls: ["./showcase-company.component.css"],
})
export class ShowcaseCompanyComponent implements OnInit {
  @ViewChild("unauthorizedModal") unauthorizedModal: ModalComponent;

  companySectorCodes = [];
  companySizes = [];

  showcaseId: number;
  pageSize: number = 5;
  pageNumber: number = 0;
  companyName = null;
  location: string;
  address: string;
  sectorCompanyList = null;
  generalContractor = null;
  sectorOrPartialContractor = null;
  companySizeList = null;
  employer: string;
  designer: boolean = false;
  error = "no_error";
  sectorCompanySelected = null;
  companySizeSelected = null;

  typeCompanyList = null;
  specializationTypes = null;

  publicCompanyCards: Array<ShowcaseCard> = [];
  showMoreCompanies: boolean = false;

  display = "none";
  displayError = "none";
  displaySuccess = "none";

  userTenders: Array<TenderCard> = [];
  currentCompany = null;
  form: FormGroup = null;

  searchForm = new FormGroup({
    companyName: new FormControl(null),
    companyLocation: new FormControl(null),
    companyAddress: new FormControl(null),
    companySectorCode: new FormControl(null),
    companyGeneralContractor: new FormControl(null),
    companySectorContractor: new FormControl(null),
    companySize: new FormControl(null),
  });

  profile: Profile = {};
  showMoreTenders = false;
  pageNumberTenders = 0;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    window["moment"] = moment;
    this.profile = JSON.parse(localStorage.getItem("PROFILE"));

    this.commonService
      .getProfile()
      .then((profile: Profile) => {
        console.log("User logged in");
        this.profile = profile;
        if (!profile.registryCompleted) {
          this.unauthorizedModal.open();
        }else {
          this.searchCompanies();
          this.loadUserTenders();
        }
    }).catch((error) => {
      console.log("User not logged in. Redirect to login");
      console.log(error);
      this.router.navigate(["/login"], {
        queryParams: {
          fromCompanyShowcase: "yes"
        },
      });
    });
    //create form for modal
    this.form = this.fb.group({
      tenderNumber: [null, Validators.required],
    });

    //typeCompanyList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("TYPE_COMPANY")
      .subscribe(
        (data) => {
          this.typeCompanyList = data.items;
          console.log(
            "Company Sector: " + JSON.stringify(this.typeCompanyList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare typeCompanyList.";
          console.log(error);
        }
      );
    //sectorCompanyList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SECTOR_COMPANY")
      .subscribe(
        (data) => {
          this.sectorCompanyList = data.items;
          console.log(
            "Company Sector: " + JSON.stringify(this.sectorCompanyList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista dei settori di impresa.";
          console.log(error);
        }
      );
    //companySizeList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SIZE_COMPANY")
      .subscribe(
        (data) => {
          this.companySizeList = data.items;
          console.log("Company Size: " + JSON.stringify(this.companySizeList));
        },
        (error) => {
          this.error =
            "Impossibile caricare la lista del numero di dipendenti.";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SPECIALIZATION")
      .subscribe(
        (data) => {
          this.specializationTypes = data.items;
          console.log(
            "Specializations: " + JSON.stringify(this.specializationTypes)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle specializzazioni.";
          console.log(error);
        }
      );

   
   
  }

  loadUserTenders() {
    this.commonService
      .getTenderService()
      .tenderGet(5, this.pageNumberTenders, "ONGOING")
      .subscribe(
        (res) => {
          console.log("Tenderlist: " + JSON.stringify(res));
          this.showMoreTenders =
            res.paging.pageNumber < res.paging.totalPages - 1;
          console.log("more tender cards " + this.showMoreTenders);
          this.userTenders = this.userTenders.concat(res.tenders);
        },
        (error) => {
          console.error(error);

          this.showcaseId = null;
        }
      );
  }

  loadMoreUserTenders() {
    this.pageNumberTenders++;
    this.loadUserTenders();
  }

  searchCompanies() {
    if (!this.profile.registryCompleted) {
      this.unauthorizedModal.open();
      return;
    }
    this.pageNumber = 0;
    this.publicCompanyCards = [];

    this.sectorCompanySelected = this.searchForm.get("companySectorCode").value;
    this.companySizeSelected = this.searchForm.get("companySize").value;
    this.location = this.searchForm.get("companyLocation").value;
    this.address = this.searchForm.get("companyAddress").value;
    this.companyName = this.searchForm.get("companyName").value;
    this.generalContractor = this.searchForm.get(
      "companyGeneralContractor"
    ).value;
    this.sectorOrPartialContractor = this.searchForm.get(
      "companySectorContractor"
    ).value;

    console.log(
      "Sector = " +
        this.sectorCompanySelected +
        "; location = " +
        this.location +
        "; address = " +
        this.address +
        "; Company name = " +
        this.companyName +
        "; Company size = " +
        this.companySizeSelected +
        "; General contractor = " +
        this.generalContractor +
        "; Sector contractor = " +
        this.sectorOrPartialContractor
    );

    this.loadCards();
  }

  loadCards() {
    this.commonService
      .getShowcaseService()
      .showcaseGet(
        this.showcaseId,
        this.pageSize,
        this.pageNumber,
        this.companyName,
        this.location,
        this.sectorCompanySelected,
        this.generalContractor,
        this.sectorOrPartialContractor,
        this.companySizeSelected,
        this.employer,
        (this.designer = false)
      )
      .subscribe(
        (res: ShowcaseList) => {
          // console.log("Showcase list: " + JSON.stringify(res));
          this.publicCompanyCards = this.publicCompanyCards.concat(
            res.profileDetails
          );
          this.showMoreCompanies =
            res.paging.pageNumber < res.paging.totalPages - 1;
          localStorage.removeItem("SHOWCASE_ID");
          this.showcaseId = null;
          // console.log(
          //   "Public company cards:" + JSON.stringify(this.publicCompanyCards)
          // );
        },
        (error) => {
          console.error(error);

          localStorage.removeItem("SHOWCASE_ID");
          this.showcaseId = null;
        }
      );
  }

  GetSpecializationDescription(code: string) {
    for (let i of this.specializationTypes) {
      if (i.code == code) {
        return i.description;
      }
    }
    return null;
  }

  loadMoreCards() {
    this.pageNumber = this.pageNumber + 1;
    this.loadCards();
  }

  //converts the code into the description
  getDimentionCompany(code: string) {
    for (let i of this.companySizeList) {
      if (i.code == code) {
        return i.description;
      }
    }
    return null;
  }

  getSectorCompany(code: string) {
    for (let i of this.sectorCompanyList) {
      if (i.code == code) {
        return i.description;
      }
    }
    return null;
  }

  getTypeCompany(code: string) {
    for (let i of this.typeCompanyList) {
      if (i.code == code) {
        return i.description;
      }
    }

    return null;
  }

  changeModal() {
    switch (this.display) {
      case "none":
        this.display = "block";
        break;
      case "block":
        this.display = "none";
        break;
    }
  }

  getStatusDesciption(statusCode: string) {
    return GetTenderStatusDescription(statusCode);
  }

  getFormattedDate(date: string) {
    return moment(date).format("DD-MM-YYYY");
  }

  getCategoryName(categoryCode: string) {
    return GetTenderCategoryByCode(categoryCode).description;
  }

  getCompanyInfo(companyCard) {
    this.currentCompany = companyCard;
    console.log("Azienda corrente: " + JSON.stringify(this.currentCompany));
  }

  unauthorizedModalSubmit() {
    this.router.navigate(['/areariservata'], { queryParams: { tabToLoad: 'profile', fromRestrictedArea: true, returnResource:  'aziende'} });
    this.unauthorizedModal.close();
  }

  onSubmit() {
    let profile = localStorage.getItem("PROFILE");
    console.log(this.form.value);
    let tender: Tender;
    let selectedTenderId = this.form.value.tenderNumber;
    this.commonService
      .getTenderService()
      .tenderTenderIdGet(selectedTenderId)
      .subscribe(
        (data) => {
          tender = data;
          console.log("tender selezionato");
          console.log(tender);
        },
        (error) => {
          console.log(error);
          console.log("Tender does not exist");
          this.changeModal();
          this.changeModalError();
        }
      );

    let tenderInvitation: TenderInvitation = {
      customerId: this.currentCompany.profile.customerId,
      customerName: this.currentCompany.profile.companyName,
    };

    this.commonService
      .getTenderInvitationService()
      .tenderTenderIdInvitationPost(selectedTenderId, tenderInvitation)
      .subscribe(
        (res) => {
          console.log(res);
          this.changeModal();
          this.changeModalSuccess();
        },
        (error) => {
          console.log(error);
          this.changeModal();
          this.changeModalError();
        }
      );
  }

  changeModalError() {
    switch (this.displayError) {
      case "none":
        this.displayError = "block";
        break;
      case "block":
        this.displayError = "none";
        break;
    }
    console.log(this.displayError);
  }

  changeModalSuccess() {
    switch (this.displaySuccess) {
      case "none":
        this.displaySuccess = "block";
        break;
      case "block":
        this.displaySuccess = "none";
        break;
    }
    console.log(this.displaySuccess);
  }

  checkNumber(number) {
    if (number != null && number != undefined) {
      return number;
    } else {
      return "0";
    }
  }
}
